import {
  $,
  appState,
  mods,
  platformLabel,
} from './app-state';
import { keyFromKeyboardEvent } from './keyboard';
import type { InputMessage } from '../shared/datachannel';

function sendInput(msg: InputMessage): void {
  appState.controller?.sendInput(msg);
}

function releaseAllMods(): void {
  for (const m of Array.from(mods)) {
    sendInput({ type: 'keyup', key: m });
  }
  mods.clear();
  document.querySelectorAll<HTMLElement>('.kbd-mod').forEach((b) => b.classList.remove('active'));
}

function updateShortcutButton(): void {
  const button = $('tb-shortcut');
  const label = button.querySelector('span');
  const os = appState.remotePlatform === 'unknown' ? '远端系统' : platformLabel(appState.remotePlatform);
  button.classList.toggle('active', appState.shortcutMode === 'raw');
  button.title = appState.shortcutMode === 'raw'
    ? `原始修饰键（${os}）· 再次点击启用跨系统兼容`
    : `跨系统快捷键兼容（${os}）· 再次点击发送原始按键`;
  if (label) label.textContent = appState.shortcutMode === 'raw' ? '原始键' : '兼容键';
}

async function pasteClipboardAndTriggerRemote(): Promise<void> {
  if (!appState.controller || !(await appState.controller.pasteToRemote())) return;
  const modifier = appState.remotePlatform === 'macos' ? 'Meta' : 'Control';
  appState.controller.sendInput({ type: 'keydown', key: modifier });
  appState.controller.sendInput({ type: 'keydown', key: 'v' });
  appState.controller.sendInput({ type: 'keyup', key: 'v' });
  appState.controller.sendInput({ type: 'keyup', key: modifier });
}

function bindKeyboard(): void {
  const layer = $('kbd-layer');
  const text = $('kbd-text') as HTMLInputElement;

  $('tb-kbd').addEventListener('click', () => {
    const hidden = layer.classList.toggle('hidden');
    if (hidden) {
      releaseAllMods();
    } else {
      text.focus();
    }
  });

  // 锁存修饰键
  document.querySelectorAll<HTMLElement>('.kbd-mod').forEach((b) => {
    b.addEventListener('click', () => {
      const mod = b.dataset.mod!;
      if (mods.has(mod)) {
        sendInput({ type: 'keyup', key: mod });
        mods.delete(mod);
        b.classList.remove('active');
      } else {
        sendInput({ type: 'keydown', key: mod });
        mods.add(mod);
        b.classList.add('active');
      }
    });
  });

  // 一次性特殊键
  document.querySelectorAll<HTMLElement>('.kbd-key').forEach((b) => {
    b.addEventListener('click', () => {
      const key = b.dataset.key!;
      sendInput({ type: 'keydown', key });
      sendInput({ type: 'keyup', key });
    });
  });

  // 系统/硬件键盘输入
  text.addEventListener('keydown', (e) => {
    // 这个输入框是虚拟键盘的文字入口；保留本地 Cmd/Ctrl+V，方便把文字粘进输入框。
    if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'v') return;
    e.preventDefault();
    const key = keyFromKeyboardEvent(e);
    if (e.key.length === 1) {
      sendInput({ type: 'keydown', key });
      sendInput({ type: 'keyup', key });
    } else if (['Enter', 'Backspace', 'Delete', 'Tab', 'Escape', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
      sendInput({ type: 'keydown', key });
      sendInput({ type: 'keyup', key });
    }
  });
}

export {
  sendInput,
  releaseAllMods,
  updateShortcutButton,
  pasteClipboardAndTriggerRemote,
  bindKeyboard,
};
